var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagThailand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagThailand_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagThailand_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagThailand_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagThailand_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagThailand_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CB0028",
    d: "M-12 44.122h70.482V3H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-12 37.255h70.482V9.859H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A237B",
    d: "M-12 30.413h70.482V16.707H-12z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0icnJpbWRkbnNmYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJldDQ5N2ZhYWRiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3JyaW1kZG5zZmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNycmltZGRuc2ZhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjZXQ0OTdmYWFkYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0NCMDAyOCIgZD0iTTAgNDEuMTIyTDcwLjQ4MiA0MS4xMjIgNzAuNDgyIDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTAgMzQuMjU1TDcwLjQ4MiAzNC4yNTUgNzAuNDgyIDYuODU5IDAgNi44NTl6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMUEyMzdCIiBkPSJNMCAyNy40MTNMNzAuNDgyIDI3LjQxMyA3MC40ODIgMTMuNzA3IDAgMTMuNzA3eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagThailand as ReactComponent };